module.exports = __webpack_public_path__ + "static/media/search-outlined.98118c2a.svg";